"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInAdminMode = void 0;
function isInAdminMode(authenticatedUser) {
    return (authenticatedUser.in_personal_admin_mode === true ||
        authenticatedUser.work_status === 'IN_ADMIN_MODE');
}
exports.isInAdminMode = isInAdminMode;
